import { tasksRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';
import { AssociateAutomationModel } from '../types/associate-automation-model';

export const useDisassociateAutomation = () =>
  useMutation<void, unknown, AssociateAutomationModel>((automation) =>
    tasksRepo.disassociateAutomation(automation),
  );
